module.exports = __webpack_public_path__ + "media/images/img_ttl-laboratory-558ac2126858ee08108e83b877cdc36d.png";